import {
  call,
  put,
  fork,
  select,
  takeLatest
} from 'redux-saga/effects';
import {delay} from 'redux-saga';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {
   navigationRoutes,
   navigationSteps
} from '../../../navigation/navigationHelpers';
import {
  LOAD_CONTENT,
  DL_PAGE_LOADED
} from './myplan';
import {
  showGlobalSpinner,
  hideGlobalSpinner
} from '../../../common/common';

// WATCHERS
export function* loadContentWatch() {
  yield takeLatest(LOAD_CONTENT, loadContentWorker);
}

// WORKERS
export function* loadContentWorker() {
  try {
    yield put(showGlobalSpinner({hideContent: true, initiator: 'myplan load'}));

    const success1 = yield call(dataProvider.load, [
      {state: 'auth'},
      {state: 'customer'},
      {state: 'context', param: 'true'}
    ]);

    if (!success1) {
      return;
    }

    yield delay(0); // HACK: delay necessary to make sure selected state is up-to-date
    const state = yield select();
    const consumerType = _.get(state, 'common.consumerType', '');
    const isOmniContext = consumerType === 'Einstein360' || consumerType === 'Etail';
    const isPlanAvailable = _.get(state, 'plan.isPlanAvailable', true);

    if (!isOmniContext || isPlanAvailable) {
      const success2 = yield call(dataProvider.load, [
        [{state: 'plan'}, {state: 'equipment'}]
      ]);

      if (!success2) {
        return;
      }
    }

    yield put(hideGlobalSpinner());
    yield put({
      type: DL_PAGE_LOADED
    });

  } catch(e) {
    //console.log(e);
    yield put(hideGlobalSpinner());
    browserHistory.push(navigationRoutes[navigationSteps.myPlan.ERROR].path);
  }
}

export default function* myplanSagas() {
  yield [
    fork(loadContentWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/myplan/myplanSagas.js
 **/